/**
 * @module header
 */

const state = {
  user: null,
  storeList: [],
  appList: {},
}

const mutations = {
  setUser (state, payload) {
    state.user = payload
  },
  setUserInfo (state, payload) {
    state.user.display_name = payload.display_name
    state.user.email = payload.email
  },
  setAppList (state, payload) {
    state.appList = payload
  },
  setStoreList (state, payload) {
    state.storeList = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations
}
